import { Types } from "src/api/@types";
import { generateGetEndpoint, generatePostEndpoint } from "src/api/@utils";
// import { baseURL as rootURL } from "..";

// THIS IS A BAD WAY TO DO THIS BUT IS THE CURRENT WORKAROUND DUE TO CIRCULAR DEPENDENCY ISSUES
const baseURL = "/business-discussion" + "/type"

const useBusinessDiscussionTypeEndpoints = () => {
    const create = generatePostEndpoint<{ type: any }, string>(baseURL + "/create");
    const deleteType = generatePostEndpoint<{id: string}, {message: string, deleted: boolean, type: any}>(baseURL + "/delete");
    const edit = generatePostEndpoint<{ type: any }, any>(baseURL + "/edit");
    const fetch = generatePostEndpoint<{ id: any }, any>(baseURL + "/fetch");
    const fetchAll = generateGetEndpoint<Types.BusinessDiscussion.Type.FetchAll>(baseURL + "/fetch-all");
    const fetchRoles = generateGetEndpoint<Array<any>>(baseURL + "/fetch-roles");
    const view = generateGetEndpoint<Array<any>>(baseURL + "/view");

    return {
        create,
        deleteType,
        edit,
        fetch,
        fetchAll,
        fetchRoles,
        view
    }
}

export {
    baseURL,
    useBusinessDiscussionTypeEndpoints
};